import { colFormRef } from './consts';

export default function (editor, opts = {}) {
  const c = opts;
  const bm = editor.BlockManager;
  const pfx = c.pfx;

  if (c.blocks.indexOf(colFormRef) >= 0) {
    bm.add(colFormRef, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="50">
        <path d="M22,5.5 C22,5.2 21.5,5 20.75,5 L3.25,5 C2.5,5 2,5.2 2,5.5 L2,8.5 C2,8.8 2.5,9 3.25,9 L20.75,9 C21.5,9 22,8.8 22,8.5 L22,5.5 Z M21,8 L3,8 L3,6 L21,6 L21,8 Z" fill-rule="nonzero"></path>
        <path d="M22,10.5 C22,10.2 21.5,10 20.75,10 L3.25,10 C2.5,10 2,10.2 2,10.5 L2,13.5 C2,13.8 2.5,14 3.25,14 L20.75,14 C21.5,14 22,13.8 22,13.5 L22,10.5 Z M21,13 L3,13 L3,11 L21,11 L21,13 Z" fill-rule="nonzero"></path>
        <rect x="2" y="15" width="10" height="3"/>
      </svg>
      <div class="gjs-block-label">${c.labelColForm}</div>`,
      category: c.labelColFormCategory,
      content: `
    <form class="form ${pfx} dc-form-default dc-form-bordered"
      onsubmit="return changePassword(event)" data-gjs-type="change-passowrd-form" data-js="change-password-form">
        <div class="col-12 col-md-12">
          <h4 class="title">Change Password</h4>
        </div>
        <div class="form-container row mx-auto" draggable="false" data-gjs-copyable="false" data-gjs-selectable="true"
            data-gjs-custom-name="Form Container">
                <div style="display:none" class="alert alert-danger alert-message"></div>
                <div style="display:none" class="alert alert-success success-message"></div>
                <div class="form-group col-12 col-md-12">
                    <label class="label">Old Password</label>
                    <input name="oldPassword" placeholder="Old Password" type="password" required
                        class="form-control input--style" />
                </div>
                <div class="form-group col-12 col-md-12">
                    <label class="label">New Password</label>
                    <input name="password" placeholder="New Password" type="password" required
                        class="form-control input--style" />
                </div>
                <div class="form-group col-12 col-md-12">
                    <label class="label">Confirm Password</label>
                    <input name="confirmPassword" type="password" placeholder="Confirm Password" required
                        class="form-control input--style" />
                </div>
                <div class="form-group p-t-10 no-border-bottom col-12 col-md-12">
                  <button role="button" type="submit" class="btn btn-primary">Update Password</button>
                </div>
        </div>
    </form>
      `,
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="#" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        c.labelColForm
      }?"></i>
        </a>
      </span>
    `,
    });
  }
}
